/* eslint-disable react-hooks/exhaustive-deps */
import React, {FC, useEffect, useMemo, useState} from 'react'
import CustomLabel from '../../../../../common/components/label/CustomLabel'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import Select from 'react-select'
import clsx from 'clsx'
import {useIntl} from 'react-intl'
import {getListFloor} from '../../../../../common/core/dropdown/request'
import {selectCustomStyle} from '../../../../../common/styles/selectCustom'
import {RadioButton} from '../../../../../common/components/RadioButton/RadioButton'
import {
  getListMaterielMoteur,
  getListUsageOption,
  getUsageCriteria,
  putUsageCritere,
  putUsageMaterial,
  putUsageOption,
} from '../../core/termofuse/request'
import {useNavigate, useParams} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'
import {useAuth} from '../../../../auth'
import {toast} from 'react-toastify'
import {useThemeMode} from '../../../../../../_metronic/partials/layout/theme-mode/ThemeModeProvider'
import {getUsageCounters} from '../../core/_requests'
import {InfoModal} from '../../../../../common/components/modal/InfoModal'
import {Button, Modal} from 'react-bootstrap'
import * as lodash from 'lodash'
import {
  setIsThereNonSavedForm,
  setProjectTab3,
  setProjectTab4,
} from '../../../../../common/ModalPopup/reducer'
import {WarningModal} from '../../../../../common/components/modal/WarningModal'
const initialUsageForm = {
  MovePerson: false,
  PersonNumber: '',
  MoveMaterial: false,
  MaterialWeight: '',
  MaterialHeight: '',
  MaterialWidth: '',
  MaterialLength: '',
  BuildingSubLevel: '',
  BuildingSupLevel: '',
  BuildingSelectedLevel: '',
  BuildingTotalHeight: '',
}

const npFormValidationSchema3 = Yup.object().shape({
  MovePerson: Yup.string()
    .min(2, 'Minimunm de 2 caractère')
    .max(50, 'Minimunm de 50 caractère')
    .required(''),
})

type NPTab3FormProps = {
  onCancelClick?: () => void
  enabled?: boolean
}

interface CustomOptionProps {
  value: string
  label: string
  isChecked: boolean
}

export const selectDarkStyle = {
  menu: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: '#1b1b29',
    color: 'white',
  }),
  singleValue: (base: any, props: any) => {
    return {
      ...base,
      color: '#FFF',
    }
  },
  control: (provided: any, state: any) => ({
    ...provided,
    borderColor: state.isFocused ? '#5e627800' : '#5e627800',
    boxShadow: state.isFocused ? '#5e627850' : '#5e627850',
    '&:hover': {
      borderColor: state.isFocused ? '#5e627800' : '#5e627800',
      boxShadow: state.isFocused ? '#5e6278ac' : '#5e6278ac',
      backgroundColor: '#2b2b40',
    },
    backgroundColor: '#1b1b29',
    height: 40,
    borderRadius: '0.475rem',
  }),
}
const NPTab3Form: FC<NPTab3FormProps> = ({onCancelClick, enabled}) => {
  const {mode} = useThemeMode()
  const intl = useIntl()
  const navigate = useNavigate()
  const {setAuthMessage, logout} = useAuth()
  const {pGuid} = useParams()
  const dispatch = useDispatch()
  const projectData = useSelector((state: any) => state.projectData)
  const Submitted = useSelector((state: any) => state?.projectStatus?.Submitted)
  const [nifSupOptions, setNifSupOption] = useState<any[]>([])
  const [optionMaterial, setOptionMaterial] = useState<any[]>([])
  const [listeMoteurs, setListeMoteurs] = useState<any[]>([])
  const [usageData, setUsageData] = useState<any>(null)
  const [initCriteria, setInitCriteria] = useState<any>(null)
  const [w2go, setW2go] = useState<'tab1' | 'tab3' | 'tab4' | 'tab2'>('tab1')
  const [showbq, setShowbq] = useState<boolean>(false)
  const [allowedNext, setAllowedNext] = useState<boolean>(false)
  const [isSearchClicked, setIsSearchClicked] = useState<boolean>(false)
  const npform3 = useFormik({
    initialValues: initialUsageForm,
    validationSchema: npFormValidationSchema3,
    onSubmit: (values) => {
      console.log(values)
    },
  })

  //const [isMovePerson, setIsMovePerson] = useState(false)
  //const [isMoveMaterial, setIsMoveMaterial] = useState(false)
  const [isSelectedMaterial, setSelectedMaterial] = useState<boolean>(false)
  const handleChekboxChange = () => {
    //setIsMovePerson(!isMovePerson)
    setOnIsUptade(true)
    npform3.setFieldValue('MovePerson', !npform3.values.MovePerson)
  }
  const handleChekboxChange2 = () => {
    //setIsMoveMaterial(!isMoveMaterial)
    setOnIsUptade(true)
    npform3.setFieldValue('MoveMaterial', !npform3.values.MoveMaterial)
  }

  // const handleBackPress = () => {
  //   navigate('/new-project/tab2' + (pGuid ? '/' + pGuid : ''), {replace: true})
  // }

  const handleBackPress = () => {
    setW2go('tab2')
    if (isThereModif) {
      setShowbq(true)
    } else {
      navigate('/new-project/tab2' + (pGuid ? '/' + pGuid : ''), {replace: true})
    }
  }

  const loadUsageCriteria = async () => {
    const response = await getUsageCriteria(
      pGuid || projectData?.tab1?.data?.Guid || '',
      (message: string) => {
        setAuthMessage(message)
        logout()
      },
      ({Message, MessageType, Toast, ToastType}) => {
        if (Message && MessageType === 'Success') {
          //
        } else if (Message && MessageType === 'Error') {
          //
        } else if (Toast && ToastType === 'Success') {
          toast(Toast, {type: 'success'})
        } else if (Toast && ToastType === 'Error') {
          toast(Toast, {type: 'error'})
        }
      }
    )
    console.log('response', response)
    if (response?.data && response?.data?.data) {
      npform3.setValues(response?.data?.data)
      setInitCriteria(response?.data?.data)
      if (response?.data?.data?.MoveMaterial || response?.data?.data?.MovePerson) {
        const usageRes = await getUsageCounters(
          pGuid || projectData?.tab1?.data?.Guid,
          (message: string) => {
            setAuthMessage(message)
            logout()
          },
          ({Message, MessageType, Toast, ToastType}) => {
            if (Message && MessageType === 'Success') {
              //
            } else if (Message && MessageType === 'Error') {
              //
            } else if (Toast && ToastType === 'Success') {
              toast(Toast, {type: 'success'})
            } else if (Toast && ToastType === 'Error') {
              toast(Toast, {type: 'error'})
            }
          }
        )
        if (usageRes?.data?.data) {
          setUsageData(usageRes?.data?.data)
        }
      }
      const cde: any = {...response?.data?.data}
      if (
        ((cde?.MovePerson && cde?.PersonNumber != null && cde?.PersonNumber !== '') ||
          (cde?.MoveMaterial && cde?.MaterialWeight != null && cde?.MaterialWeight !== '')) &&
        cde?.BuildingSupLevel != null &&
        cde?.BuildingSupLevel !== '' &&
        cde?.BuildingSubLevel != null &&
        cde?.BuildingSubLevel !== '' &&
        cde?.BuildingTotalHeight != null &&
        cde?.BuildingTotalHeight !== ''
      ) {
        loadUsageOption()
        loadListMaterielMoteur()
      }
      //setIsMovePerson(response?.data?.data?.MovePerson)
      //setIsMoveMaterial(response?.data?.data?.MoveMaterial)
    }
  }

  let isThereModif =
    (initCriteria && !lodash.isEqual({...npform3.values}, {...initCriteria})) ||
    (!initCriteria && !lodash.isEqual({...npform3.values}, {...initialUsageForm}))
      ? true
      : false
  useMemo(() => {
    console.log('isThereModif', isThereModif)

    dispatch(setIsThereNonSavedForm(isThereModif))
  }, [isThereModif])

  useEffect(() => {
    if (enabled) {
      loadUsageCriteria()
    }
  }, [enabled])

  useEffect(() => {
    if (enabled) {
      loadListFloor()
    }
  }, [enabled, npform3?.values?.BuildingSubLevel, npform3?.values?.BuildingSupLevel])

  // useEffect(() => {
  //   loadUsageOption()
  // }, [])

  const loadUsageOption = async () => {
    const response = await getListUsageOption(pGuid || projectData?.tab1?.data?.Guid || '')
    if (response?.data && response?.data?.data) {
      setOptionMaterial(response?.data?.data)
    }
  }

  // useEffect(() => {
  //   loadListMaterielMoteur()
  // }, [])

  const loadListMaterielMoteur = async () => {
    const response = await getListMaterielMoteur(pGuid || projectData?.tab1?.data?.Guid || '')
    if (response?.data && response?.data?.data) {
      setListeMoteurs(response?.data?.data)
    }
  }
  const loadListFloor = async () => {
    if (npform3?.values?.BuildingSupLevel || npform3?.values?.BuildingSubLevel) {
      const response = await getListFloor({
        BuildingSubLevel: npform3?.values?.BuildingSubLevel || 0,
        BuildingSupLevel: npform3?.values?.BuildingSupLevel || 0,
      })
      if (response.data.data && Array.isArray(response.data.data)) {
        let BuildingSelectedLevel = npform3.values.BuildingSelectedLevel
          ? npform3.values.BuildingSelectedLevel?.split(',')
          : []
        const data = response.data.data.map((floor: any) => {
          if (
            floor?.Code === npform3.values.BuildingSelectedLevel ||
            BuildingSelectedLevel.includes(floor?.Code)
          ) {
            return {
              label: floor?.Code || '',
              value: floor?.Code || '',
              isChecked: true,
            }
          } else {
            return {
              label: floor?.Code || '',
              value: floor?.Code || '',
              isChecked: false,
            }
          }
          //return list
        })
        console.log('data', data)
        setNifSupOption(data)
        // npform3.setFieldValue('BuildingSelectedLevel', '')
        // console.log('BuildingSelectedLevel', BuildingSelectedLevel)
      }
    } else {
    }
  }

  //const [selectedOptions, setSelectedOptions] = useState<CustomOptionProps[] | any[] |any >([]);

  const handleChange = (selected: CustomOptionProps[] | any) => {
    console.log('selected', selected)
    //setSelectedOptions(selected);
  }

  const handleChangeNif = (checked: boolean, option: any) => {
    const list = [...nifSupOptions]
    const data: any = {...option.data, isChecked: checked}
    let BuildingSelectedLevelToArray = npform3.values?.BuildingSelectedLevel
      ? npform3.values?.BuildingSelectedLevel.split(',')
      : []
    if (checked) {
      BuildingSelectedLevelToArray.push(option.data?.label)
    } else if (!checked) {
      //const _BuildingSelectedLevelToArray =[...BuildingSelectedLevelToArray]
      //_BuildingSelectedLevelToArray.findIndex((label: any) => data.label === option?.data.label)
      BuildingSelectedLevelToArray = BuildingSelectedLevelToArray.filter(
        (label: any) => label !== option?.data?.label
      )
    }
    const index = list.findIndex((nifOption) => nifOption?.value === data?.value)
    console.log(index)
    if (index === -1) return
    list.splice(index, 1, data)
    setNifSupOption(list)
    npform3.setFieldValue('BuildingSelectedLevel', BuildingSelectedLevelToArray.toString())
  }
  const renderOption = (option: CustomOptionProps | any) => {
    return (
      <div
        data-bs-theme={mode}
        onClick={() => {
          if (Submitted) return
          const isChecked = !option?.data?.isChecked
          handleChangeNif(isChecked, option)
        }}
        className='d-flex gap-2 mx-4 my-2 align-items-center'
        style={{cursor: Submitted ? 'not-allowed' : 'pointer'}}
      >
        <input
          className='form-check-sm form-check-custom form-check-solid  h-15px w-15px'
          style={{
            accentColor: '#34495e',
            cursor: Submitted ? 'not-allowed' : 'pointer',
            // backgroundColor: option?.data?.isChecked ? '#e2423a' : '#9A9A9A',
          }}
          type='checkbox'
          checked={option?.data?.isChecked}
          disabled={Submitted}
          onChange={() => {
            const isChecked = !option?.data?.isChecked
            handleChangeNif(isChecked, option)
          }}
        />
        <label style={{cursor: Submitted ? 'not-allowed' : 'pointer'}}>{option.label}</label>
      </div>
    )
  }

  const onPutUsageCriteria = async () => {
    if (Submitted) return
    const response = await putUsageCritere(
      {
        ...npform3.values,
        ProjectGuid: pGuid || projectData?.tab1?.data?.Guid || '',
      },
      (message: string) => {
        setAuthMessage(message)
        logout()
      },
      ({Message, MessageType, Toast, ToastType}) => {
        if (Message && MessageType === 'Success') {
          //
        } else if (Message && MessageType === 'Error') {
          //
        } else if (Toast && ToastType === 'Success') {
          toast(Toast, {type: 'success'})
        } else if (Toast && ToastType === 'Error') {
          toast(Toast, {type: 'error'})
        }
      }
    )
    if (response?.data?.data) {
      const usageRes = await getUsageCounters(pGuid || projectData?.tab1?.data?.Guid)
      if (usageRes?.data?.data) {
        setUsageData(usageRes?.data?.data)
      }
      // const resUpdate = await getUsageCriteria(
      //   pGuid || projectData?.tab1?.data?.Guid || '',
      //   (message: string) => {
      //     setAuthMessage(message)
      //     logout()
      //   },
      //   ({Message, MessageType, Toast, ToastType}) => {
      //     if (Message && MessageType === 'Success') {
      //       //
      //     } else if (Message && MessageType === 'Error') {
      //       //
      //     } else if (Toast && ToastType === 'Success') {
      //       toast(Toast, {type: 'success'})
      //     } else if (Toast && ToastType === 'Error') {
      //       toast(Toast, {type: 'error'})
      //     }
      //   }
      // )
      // if (resUpdate?.data?.data) {
      //   npform3.setValues(resUpdate?.data?.data)
      //   setInitCriteria(resUpdate?.data?.data)
      // }
    }

    //await loadListMaterielMoteur()
    //await loadUsageOption()
    //}
  }

  const onPutUsageOption = async (data: {OptionGuid: string; OptionSelected: boolean}) => {
    if (Submitted) return
    await putUsageOption(
      {
        ...data,
        ProjectGuid: pGuid || projectData?.tab1?.data?.Guid || '',
      },
      (message: string) => {
        setAuthMessage(message)
        logout()
      },
      ({Message, MessageType, Toast, ToastType}) => {
        if (Message && MessageType === 'Success') {
          //
        } else if (Message && MessageType === 'Error') {
          //
        } else if (Toast && ToastType === 'Success') {
          toast(Toast, {type: 'success'})
        } else if (Toast && ToastType === 'Error') {
          toast(Toast, {type: 'error'})
        }
      }
    )
    await loadListMaterielMoteur()
  }

  const onPutUsageMateriel = async (data: {MaterialGuid: string; MaterialSelected: boolean}) => {
    if (Submitted) return
    await putUsageMaterial(
      {
        ...data,
        ProjectGuid: pGuid || projectData?.tab1?.data?.Guid || '',
      },
      (message: string) => {
        setAuthMessage(message)
        logout()
      },
      ({Message, MessageType, Toast, ToastType}) => {
        if (Message && MessageType === 'Success') {
          //
        } else if (Message && MessageType === 'Error') {
          //
        } else if (Toast && ToastType === 'Success') {
          toast(Toast, {type: 'success'})
        } else if (Toast && ToastType === 'Error') {
          toast(Toast, {type: 'error'})
        }
      }
    )
    await loadListMaterielMoteur()
    if (!isSelectedMaterial) {
      setSelectedMaterial(true)
    }
  }
  console.log('formik', npform3.values)
  console.log('w2go', w2go)

  const onSelectedItemMaterial = async (materiel: any) => {
    if (Submitted) return
    if (Array.isArray(optionMaterial)) {
      const _optionMaterial = Array.isArray(optionMaterial) ? [...optionMaterial] : []
      const index = optionMaterial.findIndex((opt: any) => materiel === opt)
      _optionMaterial.splice(index, 1, {
        ...materiel,
        Selected: !materiel?.Selected,
      })
      setOptionMaterial(_optionMaterial)
      await onPutUsageOption({
        OptionGuid: materiel?.Guid || '',
        OptionSelected: !materiel?.Selected,
      })
    }
  }

  const onSelectedItemMoteurMaterial = async (moteur: any) => {
    if (Submitted) return
    if (Array.isArray(optionMaterial)) {
      const moteurs = Array.isArray(listeMoteurs) ? [...listeMoteurs] : []
      const index = listeMoteurs.findIndex((opt: any) => moteur === opt)
      moteurs.splice(index, 1, {
        ...moteur,
        Selected: !moteur?.Selected,
      })
      setListeMoteurs(moteurs)
      await onPutUsageMateriel({
        MaterialSelected: !moteur?.Selected,
        MaterialGuid: moteur?.Guid || '',
      })
    }
  }
  const [openInfo, setOpenInfo] = useState<boolean>(false)
  const isDisabled = useMemo(() => {
    return !(
      ((npform3.values.MovePerson &&
        npform3?.values?.PersonNumber != null &&
        npform3?.values?.PersonNumber !== '') ||
        (npform3.values.MoveMaterial &&
          npform3.values.MaterialWeight != null &&
          npform3.values.MaterialWeight !== '')) &&
      npform3.values.BuildingSupLevel != null &&
      npform3.values.BuildingSupLevel !== '' &&
      npform3.values.BuildingSubLevel != null &&
      npform3.values.BuildingSubLevel !== '' &&
      npform3.values?.BuildingTotalHeight != null &&
      npform3.values?.BuildingTotalHeight !== ''
    )
  }, [
    npform3.values.MovePerson,
    npform3.values.PersonNumber,
    npform3.values.MoveMaterial,
    npform3.values.MaterialWeight,
    npform3.values.BuildingSupLevel,
    npform3.values.BuildingSubLevel,
    npform3.values?.BuildingTotalHeight,
  ])
  const [onIsUptade, setOnIsUptade] = useState(false)
  useEffect(() => {
    setListeMoteurs([])
    setOptionMaterial([])
    if (Submitted) return // permet de bloque l'appel putUsageCriteria
    if (isThereModif) {
      onPutUsageCriteria()
    }
  }, [
    npform3?.values?.PersonNumber,
    npform3?.values?.MaterialWeight,
    npform3.values.MaterialHeight,
    npform3.values.MaterialLength,
    npform3.values.MaterialWidth,
    npform3.values.MovePerson,
    npform3.values.MoveMaterial,
    onIsUptade,
    Submitted,
  ])

  // useEffect(() => {}, [
  //   npform3?.values?.PersonNumber,
  //   npform3?.values?.MaterialWeight,
  //   npform3.values.MaterialHeight,
  //   npform3.values.MaterialLength,
  //   npform3.values.MaterialWidth,
  //   npform3.values.MovePerson,
  //   npform3.values.MoveMaterial,
  // ])

  useEffect(() => {
    setListeMoteurs([])
    setOptionMaterial([])
  }, [
    npform3.values.BuildingSubLevel,
    npform3.values.BuildingSupLevel,
    npform3.values.BuildingSelectedLevel,
    npform3.values.BuildingTotalHeight,
  ])

  // const onNext = () => {
  //   if (pGuid) {
  //     navigate(`../tab4/${pGuid}`)
  //   } else {
  //     navigate(`../tab4`)
  //   }
  // }

  const onNextWithoutSaveClick = () => {
    setW2go('tab4')
    if (isThereModif) {
      setShowbq(true)
    } else if (!listeMoteurs.some((moteur: any) => moteur.Selected)) {
      setAllowedNext(true)
    } else {
      if (!pGuid) {
        dispatch(
          setProjectTab3({
            // data: projectDataResponse.data.data,
            data: null,
            disabled: false,
            active: false,
          })
        )
        dispatch(
          setProjectTab4({
            // ...projectData.tab3,
            data: null,
            disabled: false,
            active: true,
          })
        )
      }

      // dispatch(
      //   setProjectTab5({
      //     // ...projectData.tab3,
      //     disabled: pGuid ? false : true,
      //     active: false,
      //   })
      // )
      if (listeMoteurs.some((moteur: any) => moteur.Selected) && !isThereModif) {
        navigate('/new-project/tab4' + (pGuid ? '/' + pGuid : ''))
      }
    }
  }

  console.log('isThereModif', npform3.values)
  console.log('isThereModif', initCriteria)

  return (
    <div className='p-5'>
      <label data-bs-theme={mode} className='mb-5 fs-4'>
        {intl.formatMessage({id: 'SEARCH.CRITERIA'})}
      </label>
      <div
        data-bs-theme={mode}
        className='gap-5 justify-content-xl-between d-xl-flex flex-lg-column flex-xl-row '
      >
        <div
          style={{flex: !npform3.values.MovePerson ? 0.3 : 0.3}}
          className='  mb-3 col-xl-12 col-lg-5 col-md-6 col-sm-12 col-12 '
        >
          <div
            className={clsx(
              'align-items-center d-xl-flex d-lg-flex d-md-flex d-sm-column d-column position-relative ',
              {
                'border border-2 rounded-4 border-secondary py-3': npform3.values.MovePerson,
              }
            )}
          >
            <div className='d-xl-flex d-lg-flex d-md-flex d-sm-flex gap-3 flex-column flex-md-row'>
              <div
                className='form-check form-check-custom form-check-solid '
                style={{marginLeft: 10}}
              >
                <input
                  className={'form-check-input fs-3 '}
                  type='checkbox'
                  onChange={handleChekboxChange}
                  checked={npform3.values.MovePerson}
                  disabled={Submitted}
                  style={{backgroundColor: npform3.values.MovePerson ? '#e2423a' : '#9A9A9A'}}
                />
                <label data-bs-theme={mode} className='form-check-label text-nowrap'>
                  {intl.formatMessage({id: 'MOUVEMENT.OF.PEOPLE'})}
                </label>
                {!Submitted && (
                  <div style={{top: -5}}>
                    <i className='fa fa-star-of-life text-danger' style={{fontSize: 10}}></i>
                    <i className='fa fa-star-of-life text-danger ' style={{fontSize: 10}}></i>
                  </div>
                )}
              </div>
              <div
                className={clsx({
                  'form-check-custom my-1': npform3.values.MovePerson,
                  'd-none': !npform3.values.MovePerson,
                })}
              >
                <input
                  style={{width: 80, fontSize: '12px'}}
                  type='text'
                  className='form-control form-control-solid fst-italic'
                  placeholder={intl.formatMessage({id: 'NUMBER'})}
                  //{...npform3.getFieldProps('PersonNumber')}
                  disabled={Submitted}
                  value={npform3.values.PersonNumber}
                  onChange={(e) => {
                    if (Submitted) return
                    setOnIsUptade(true)
                    npform3.setFieldValue('PersonNumber', e?.target?.value)
                  }}
                />
                <div style={{top: -5}}>
                  <i className='fa fa-star-of-life text-danger ' style={{fontSize: 10}}></i>
                </div>
              </div>
            </div>
            {npform3.values.MovePerson && usageData?.CounterForPersons && (
              <div
                className={'align-items-center justify-content-center py-1 px-3 position-absolute'}
                style={{
                  backgroundColor: '#555',
                  borderRadius: 100,
                  color: '#FFF',
                  top: -12,
                  right: 10,
                }}
              >
                {usageData?.CounterForPersons}
              </div>
            )}
          </div>
        </div>
        <div style={{flex: 0.7}} className='mb-3'>
          <div
            className={clsx('d-flex align-items-center position-relative ', {
              'border border-2 rounded-4 border-secondary py-3': npform3.values.MoveMaterial,
            })}
          >
            <div className='d-xl-flex d-lg-flex d-md-flex d-sm-flex gap-4 flex-column flex-md-row'>
              <div
                className='form-check form-check-custom form-check-solid text-end me-5'
                style={{marginLeft: 10}}
              >
                <input
                  className='form-check-input fs-3'
                  style={{backgroundColor: npform3.values.MoveMaterial ? '#e2423a' : '#9A9A9A'}}
                  type='checkbox'
                  id='flexCheckDefault'
                  onChange={handleChekboxChange2}
                  checked={npform3.values.MoveMaterial}
                  disabled={Submitted}
                  //onChange={MovePerson}
                />
                <label className='form-check-label text-nowrap'>
                  {intl.formatMessage({id: 'MOUVEMENT.OF.MATERIALS'})}
                </label>
                {!Submitted && (
                  <div className='d-flex' style={{top: -5}}>
                    <i className='fa fa-star-of-life text-danger' style={{fontSize: 10}}></i>
                    <i className='fa fa-star-of-life text-danger' style={{fontSize: 10}}></i>
                  </div>
                )}
              </div>
              <div
                className={clsx(
                  'form-check form-check-custom form-check-solid flex-md-wrap flex-sm-wrap flex-wrap',
                  {'d-flex': npform3.values.MoveMaterial, 'd-none': !npform3.values.MoveMaterial}
                )}
              >
                {/* <div className='d-flex align-items-center me-1'>
                  <label className='form-check-label text-dark me-2'>
                    {intl.formatMessage({id: 'W'})}
                  </label>
                  <input
                    type='number'
                    placeholder={intl.formatMessage({id: 'WEIGHT'})}
                    className='form-control form-control-solid fst-italic'
                    style={{width: 82, fontSize: '12px'}}
                    {...npform3.getFieldProps('MaterialWeight')}
                  />
                  <label className='form-check-label text-dark'>Kg</label>
                  <div style={{top: -5}}>
                    <i className='fa fa-star-of-life text-danger' style={{fontSize: 10}}></i>
                  </div>
                </div> */}
                {/* <div className='d-flex align-items-center my-1 me-5'>
                  <label className='form-check-label text-dark me-2'>H</label>
                  <input
                    type='number'
                    placeholder={intl.formatMessage({id: 'HEIGHT'})}
                    className='form-control form-control-solid fst-italic'
                    style={{width: 82, fontSize: '12px'}}
                    {...npform3.getFieldProps('MaterialHeight')}
                  />
                  <label className='form-check-label text-dark'>Cm</label>
                </div> */}
                {/* <div className='d-flex align-items-center my-1 me-5'>
                  <label className='form-check-label text-dark me-2'>L</label>
                  <input
                    type='text'
                    placeholder={intl.formatMessage({id: 'LENGTH'})}
                    className='form-control form-control-solid fst-italic'
                    style={{width: 82, fontSize: '12px'}}
                    {...npform3.getFieldProps('MaterialWidth')}
                  />
                  <label className='form-check-label text-dark me-'>Cm</label>
                </div>  */}
                <div
                  className={clsx(
                    'form-check form-check-custom form-check-solid flex-md-wrap flex-sm-wrap flex-wrap',
                    {'d-flex': npform3.values.MoveMaterial, 'd-none': !npform3.values.MoveMaterial}
                  )}
                >
                  <div className='d-flex align-items-center me-1'>
                    <label className='form-check-label text-dark me-2'>
                      {intl.formatMessage({id: 'W'})}
                    </label>
                    <input
                      type='number'
                      placeholder={intl.formatMessage({id: 'WEIGHT'})}
                      className='form-control form-control-solid fst-italic'
                      style={{width: 82, fontSize: '12px'}}
                      //{...npform3.getFieldProps('MaterialWeight')}
                      disabled={Submitted}
                      value={npform3.values.MaterialWeight}
                      onChange={(e) => {
                        setOnIsUptade(true)
                        npform3.setFieldValue('MaterialWeight', e?.target?.value)
                      }}
                    />
                    <label className='form-check-label text-dark'>kg</label>
                    <div style={{top: -5}}>
                      <i className='fa fa-star-of-life text-danger' style={{fontSize: 10}}></i>
                    </div>
                  </div>
                  <div className='d-flex align-items-center my-1 me-5'>
                    <label className='form-check-label text-dark me-2'>H</label>
                    <input
                      type='number'
                      placeholder={intl.formatMessage({id: 'HEIGHT'})}
                      className='form-control form-control-solid fst-italic'
                      style={{width: 82, fontSize: '12px'}}
                      //{...npform3.getFieldProps('MaterialHeight')}
                      value={npform3.values.MaterialHeight}
                      disabled={Submitted}
                      onChange={(e) => {
                        setOnIsUptade(true)
                        npform3.setFieldValue('MaterialHeight', e?.target?.value)
                      }}
                    />
                    <label className='form-check-label text-dark'>mm</label>
                  </div>
                  <div className='d-flex align-items-center my-1 me-5'>
                    <label className='form-check-label text-dark me-2'>L</label>
                    <input
                      type='text'
                      placeholder={intl.formatMessage({id: 'LENGTH'})}
                      className='form-control form-control-solid fst-italic'
                      style={{width: 82, fontSize: '12px'}}
                      disabled={Submitted}
                      //{...npform3.getFieldProps('MaterialWidth')}
                      value={npform3.values.MaterialWidth}
                      onChange={(e) => {
                        setOnIsUptade(true)
                        npform3.setFieldValue('MaterialWidth', e?.target?.value)
                      }}
                    />
                    <label className='form-check-label text-dark me-'>mm</label>
                  </div>
                  <div className='d-flex align-items-center my-1'>
                    <label className='form-check-label text-dark me-2'>
                      {intl.formatMessage({id: 'L'})}
                    </label>
                    <input
                      type='text'
                      placeholder={intl.formatMessage({id: 'WIDTH'})}
                      className='form-control form-control-solid fst-italic'
                      style={{width: 82, fontSize: '12px'}}
                      disabled={Submitted}
                      // {...npform3.getFieldProps('MaterialLength')}
                      value={npform3.values.MaterialLength}
                      onChange={(e) => {
                        setOnIsUptade(true)
                        npform3.setFieldValue('MaterialLength', e?.target?.value)
                      }}
                    />
                    <label className='form-check-label text-dark'>mm</label>
                  </div>
                </div>
              </div>
            </div>
            {npform3.values.MoveMaterial && (
              <div
                className={'align-items-center justify-content-center py-1 px-3 position-absolute'}
                style={{
                  backgroundColor: '#555',
                  borderRadius: 100,
                  color: '#FFF',
                  top: -12,
                  right: 10,
                }}
              >
                {usageData?.CounterForMaterials}
              </div>
            )}
          </div>
        </div>
      </div>

      <div className='gap-5 d-lg-flex d-md-flex d-xl-flex flex-sm-column flex-xl-row justify-content-xl-between justify-content-lg-between align-items-center justify-content-md-between justify-content-sm-start flex-1'>
        <div className='border-4 w-100 bg-secondary border-secondary rounded mb-3 pb-3 d-lg-flex d-md-flex d-xl-flex d-sm-flex flex-column flex-xl-row'>
          <div className='d-flex justify-content-sm-between justify-content-lg-start align-items-center  justify-content-md-start me-4 align-items-center'>
            <div style={{marginTop: 10, marginLeft: 20}} className='d-flex '>
              <label className='fs-5'>{intl.formatMessage({id: 'LEVEL.INF'})}</label>
              <div className='mx-2' style={{top: -5}}>
                <i className='fa fa-star-of-life text-danger' style={{fontSize: 10}}></i>
              </div>
            </div>
            <div style={{marginTop: 10}}>
              <input
                type='text'
                placeholder={intl.formatMessage({id: 'NUMBER'})}
                className='form-control form-control-solid fst-italic'
                style={{width: 80, fontSize: '12px'}}
                {...npform3.getFieldProps('BuildingSubLevel')}
                disabled={Submitted}
              />
            </div>
          </div>
          <div className='d-flex me-4'>
            <div style={{marginTop: 20, marginLeft: 10}} className='d-flex'>
              <label className='fs-5'>{intl.formatMessage({id: 'HIGHER.LEVEL'})}</label>
              <div className='mx-2' style={{top: -5}}>
                <i className='fa fa-star-of-life text-danger' style={{fontSize: 10}}></i>
              </div>
            </div>
            <div style={{marginTop: 10}}>
              <input
                type='text'
                placeholder={intl.formatMessage({id: 'NUMBER'})}
                className='form-control form-control-solid fst-italic'
                style={{width: 80, fontSize: '12px'}}
                {...npform3.getFieldProps('BuildingSupLevel')}
                disabled={Submitted}
              />
            </div>
          </div>
          <div className='d-flex me-4'>
            <div style={{marginTop: 20, marginLeft: 10}} className='d-flex me-2'>
              <label className='fs-5'>{intl.formatMessage({id: 'HIGHER.LEVEL.CONCERNED'})}</label>
            </div>
            <div style={{marginTop: 10, width: '200px'}}>
              <Select
                className='form-select-solid rounded-5 fst-italic'
                placeholder={intl.formatMessage({id: 'SET.THE.LEVELS'})}
                options={nifSupOptions}
                components={{Option: renderOption}}
                onChange={handleChange}
                //value={selectedOptions}
                // isMulti
                styles={mode === 'light' ? selectCustomStyle : selectDarkStyle}
              />
            </div>
          </div>
          <div className='d-flex'>
            <div style={{marginTop: 20, marginLeft: 10}} className='d-flex'>
              <label className='fs-5'>{intl.formatMessage({id: 'TOTAL.HEIGHT'})}</label>
              <div className='mx-2' style={{top: -5}}>
                <i className='fa fa-star-of-life text-danger' style={{fontSize: 10}}></i>
              </div>
            </div>
            <div style={{marginTop: 10}} className='me-2'>
              <input
                type='text'
                placeholder={intl.formatMessage({id: 'NUMBER'})}
                className='form-control form-control-solid fst-italic'
                style={{width: 80, fontSize: '12px'}}
                {...npform3.getFieldProps('BuildingTotalHeight')}
                disabled={Submitted}
              />
            </div>
            <div style={{marginTop: 20}} className='me-4'>
              <CustomLabel text='m' />
            </div>
          </div>
        </div>
        <div
          style={{
            marginLeft: 'auto',
            cursor: isDisabled || !isThereModif || Submitted ? 'not-allowed' : 'pointer',
          }}
          className={'mb-3 d-flex bg-secondary rounded'}
        >
          <button
            className='btn btn-dark rounded'
            // style={{backgroundColor: '#7d7d7d'}}
            // h-60px
            disabled={isDisabled || !isThereModif || Submitted}
            onClick={async () => {
              if (Submitted) return
              setIsSearchClicked(true)
              if (isThereModif || onIsUptade) {
                await onPutUsageCriteria()
              }
              console.log('{...npform3.values}', {...npform3.values})
              const cde: any = {...npform3.values}
              if (
                ((cde?.MovePerson && cde?.PersonNumber != null && cde?.PersonNumber !== '') ||
                  (cde?.MoveMaterial &&
                    cde?.MaterialWeight != null &&
                    cde?.MaterialWeight !== '')) &&
                cde?.BuildingSupLevel != null &&
                cde?.BuildingSupLevel !== '' &&
                cde?.BuildingSubLevel != null &&
                cde?.BuildingSubLevel !== '' &&
                cde?.BuildingTotalHeight != null &&
                cde?.BuildingTotalHeight !== ''
              ) {
                // await loadListMaterielMoteur()
                // await loadUsageOption()
                loadUsageCriteria()
              }
            }}
          >
            <i className='fa-solid fa-magnifying-glass text-light fs-4'></i>
            <div className='text-light fs-4'>
              {' '}
              {intl.formatMessage({id: 'CONDITIONS.OF.USE.SEARCH'})}{' '}
            </div>
          </button>
        </div>
      </div>
      <div className='d-flex separator border-3 my-5 border-secondary'></div>
      <div className='gap-5 d-lg-flex d-md-flex d-xl-flex flex-sm-column flex-xl-row justify-content-xl-between justify-content-lg-between align-items-start justify-content-md-between justify-content-sm-start flex-1'>
        <div style={{flex: 0.15}} className='bg-gray-200 rounded-4 px-3'>
          <div className='flex-column  align-items-center' style={{marginLeft: 0}}>
            <label className='fs-5 fw-bold mb-5 mt-5'>
              {intl.formatMessage({id: 'MATERIAL.OPTIONS'})}
            </label>
            {optionMaterial &&
              Array.isArray(optionMaterial) &&
              optionMaterial?.map((materiel: any) => {
                return (
                  <div key={materiel?.Guid} className='d-flex align-items-center mb-5'>
                    <input
                      className='form-check-input fs-3 me-4'
                      onChange={() => onSelectedItemMaterial(materiel)}
                      checked={materiel?.Selected}
                      disabled={Submitted}
                      type='checkbox'
                      style={{backgroundColor: materiel?.Selected ? '#e2423a' : '#9A9A9A'}}
                    />
                    <label style={{flex: 0.9}} className='fst-italic fw-bold'>
                      {materiel?.Name || ''}
                    </label>
                  </div>
                )
              })}
          </div>
        </div>
        <div style={{flex: 0.85}} className='px-3 py-3'>
          <div className='flex-column'>
            {Array.isArray(listeMoteurs) && (
              <>
                <span>
                  {' '}
                  {listeMoteurs.length} {listeMoteurs.length > 1 ? 'éléments' : 'élément'}
                </span>
                {listeMoteurs.length > 0 && (
                  <div className='d-flex separator border-3 my-3 border-secondary' />
                )}
              </>
            )}
            {Array.isArray(listeMoteurs) &&
              listeMoteurs.map((moteur: any, key) => {
                return (
                  <>
                    <div className='row p-3 flex-sm-row flex-column'>
                      <div className='mb-2 col-12 col-md-2'>
                        <img
                          className=''
                          style={{width: '100%', height: '100%', backgroundSize: 'contain'}}
                          src={
                            moteur?.FileName
                              ? `${moteur.FileName}`
                              : '/media/images/placeholder.png'
                          }
                          alt={moteur.Code}
                        />
                      </div>

                      <div className='mb-2 flex-column px-3 col-12'>
                        <div className='fw-bolder'>{moteur?.Code}</div>
                        <div className='fw-bolder'>{moteur?.Name}</div>
                        <section dangerouslySetInnerHTML={{__html: moteur?.Description}}></section>
                      </div>
                      <div className='flex-md-column col-12 mb-2 flex-sm-row'>
                        <div>
                          <div className=''>
                            <span className='fw-bolder'>Dim Cabine (L × l) :</span>
                            <span className=''>
                              {' '}
                              {moteur?.Width} mm * {moteur?.Length} mm{' '}
                            </span>
                          </div>
                          <div className=''>
                            <span className='fw-bolder'>{intl.formatMessage({id: 'PAYLOAD'})}</span>
                            <span className=''> {moteur?.Weight} kg </span>
                          </div>
                        </div>

                        <div className='fw-bolder text-dark d-flex align-items-center'>
                          <span
                            style={{
                              margin: 10,
                              width: 200,
                              height: 24,
                              border: '2px solid #e74c3c',
                              borderRadius: 100,
                            }}
                            className='mx-3 d-flex align-items-center justify-content-center'
                            onClick={(e) => {
                              window
                                ?.open(`/media/encombrement/${moteur.Code}.pdf`, '_blank')
                                ?.focus()
                            }}
                          >
                            <i className='text-danger'></i>
                            {'Voir encombrement'}
                          </span>
                        </div>

                        <div className='position-absolute bottom-0 end-0'>
                          <RadioButton
                            handleClick={() => onSelectedItemMoteurMaterial(moteur)}
                            checked={moteur?.Selected === true}
                            classNameCheckedActive=''
                            classNameCheckedInactive=''
                            classNameDefaultLabel=''
                            classNameContainer='d-flex gap-3 align-items-center'
                          />
                        </div>
                      </div>
                    </div>
                    <div className='d-flex separator border-3 my-3 border-secondary' />
                  </>
                )
              })}
          </div>
        </div>
      </div>

      <div className='d-flex justify-content-between my-5'>
        <button type='button' onClick={handleBackPress} className='btn btn-secondary'>
          <i className='ki-duotone ki-arrow-left fs-1'>
            <span className='path1'></span>
            <span className='path2'></span>
          </i>
          {intl.formatMessage({id: 'BUTTON.BACK'})}
        </button>

        <div className='d-flex' style={{marginBottom: 'auto'}}>
          <div style={{top: -5}}>
            <i className='fa fa-star-of-life text-muted' style={{fontSize: 10}}></i>
          </div>
          <label>{intl.formatMessage({id: 'DETAIL_OBLIGATAIRE'})}</label>
        </div>
        <div className='d-flex'>
          <div style={{top: -4}}>
            <i className='fa fa-star-of-life text-muted' style={{fontSize: 10}}></i>
            <i className='fa fa-star-of-life text-muted' style={{fontSize: 10}}></i>
          </div>
          <label>{intl.formatMessage({id: 'DETAIL_OBLIGATAIRE1'})}</label>
        </div>
        {npform3?.values?.BuildingSupLevel &&
          npform3?.values?.BuildingSupLevel !== '' &&
          parseInt(npform3?.values?.BuildingSupLevel) > 6 && (
            <div
              className='bg-danger flex-column text-white text-center'
              style={{width: '200px', border: '4px solid bg-danger', borderRadius: 10, height: 50}}
            >
              <div>
                <label className='fw-bold fs-4'>{intl.formatMessage({id: 'CRAM477_LIGNE1'})}</label>
              </div>
              <div>
                <label className='fw-bold fs-4'>{intl.formatMessage({id: 'CRAM477_LIGNE2'})}</label>
              </div>
            </div>
          )}
        <div className={'d-flex '}>
          <span
            className={'' + (!pGuid && !isSearchClicked ? ' not-allowed ' : ' cursor-pointer ')}
          >
            <Button
              type='button'
              variant={'secondary'}
              disabled={
                !pGuid && !isSearchClicked && lodash.isEqual(initialUsageForm, npform3.values)
              }
              onClick={onNextWithoutSaveClick}
            >
              {intl.formatMessage({id: 'SUIVANT'})}
              <i className='ki-duotone ki-arrow-right fs-1'>
                <span className='path1'></span>
                <span className='path2'></span>
              </i>
            </Button>
          </span>
        </div>
      </div>
      <InfoModal
        show={openInfo}
        onCancel={() => {
          setOpenInfo(false)
        }}
      />
      <Modal show={showbq} centered>
        <div className='text-center p-5 w-100' data-bs-theme={mode}>
          <div
            className={'w-100 rounded ' + (mode === 'dark' ? ' bg-none ' : ' bg-white ')}
            data-bs-theme={mode}
          >
            <div className='d-flex align-items-center justify-content-between'>
              <div className='fw-bolder text-gray-700 py-3'>
                {intl.formatMessage({id: 'INFORMATION'})}
              </div>
              <div
                className='p-1 cursor-pointer'
                onClick={() => {
                  setShowbq(false)
                }}
              >
                <i className='fa fa-close text-danger'></i>
              </div>
            </div>
            <div className={'text-start py-3'}>
              <div>{intl.formatMessage({id: 'BEFORE_QUIT_CONFIRM_MESSAGE'})}</div>
            </div>
            <div className='d-flex align-items-center justify-content-evenly'>
              <button
                className={'btn btn-secondary'}
                onClick={() => {
                  setShowbq(false)
                }}
              >
                {intl.formatMessage({id: 'NO'})}
              </button>
              <button
                className={'btn btn-primary'}
                onClick={async () => {
                  navigate('/new-project/' + w2go + (pGuid ? '/' + pGuid : ''))
                  await putUsageCritere(
                    {
                      ...initCriteria,
                      ProjectGuid: pGuid || projectData?.tab1?.data?.Guid || '',
                    },
                    (message: string) => {
                      setAuthMessage(message)
                      logout()
                    },
                    ({Message, MessageType, Toast, ToastType}) => {
                      if (Message && MessageType === 'Success') {
                        //
                      } else if (Message && MessageType === 'Error') {
                        //
                      } else if (Toast && ToastType === 'Success') {
                        toast(Toast, {type: 'success'})
                      } else if (Toast && ToastType === 'Error') {
                        toast(Toast, {type: 'error'})
                      }
                    }
                  )
                }}
              >
                {intl.formatMessage({id: 'YES'})}
              </button>
              {/* {!loading && (
                <button
                  className={'btn btn-primary'}
                  onClick={() => {
                    navigate('/new-project/' + w2go + (pGuid ? '/' + pGuid : ''))
                  }}
                >
                  {intl.formatMessage({id: 'YES'})}
                </button>
              )}
              {loading && (
                <button className={'btn btn-primary'} onClick={() => {}}>
                  {'...'}
                </button>
              )} */}
            </div>
          </div>
        </div>
      </Modal>
      <WarningModal
        keyInfo={'INFORMATION'}
        show={allowedNext}
        setShow={setAllowedNext}
        onConfirmCancel={() => {}}
        keyDesc={'MESSAGE_TERM_USE_NOT_SELECTED'}
      />
    </div>
  )
}

export default NPTab3Form
